<template>
  <section class="app-main">
    <el-row style="margin-bottom: 26px">
      <div class="top">
        <el-col :span="16" style="min-width: 50%">
          <div class="left br-20">
            <svg-icon icon-class="trumpet-index"></svg-icon>
            <div class="text-ellipsis">各位伙伴，让我们坚守初心使命，以坚定信念和不懈努力，在前行路上勇攀高峰，携手共创辉煌！</div>
          </div>
        </el-col>
        <div class="right">
          <div class="notice-stroke-wrap" @click="pushNoticeDialogVisible = true">
            <svg-icon icon-class="notice-stroke-index"></svg-icon>
            <el-badge class="mark" :value="noticeCount" v-if="noticeCount > 0" />
          </div>
          <div class="search-wrap">
            <svg-icon icon-class="search"></svg-icon>
          </div>
          <el-dropdown trigger="click" placement="bottom-end" :popper-class="'user-dropdown-popper'" @command="handleCommand">
            <div class="user-info-wrap br-20">
              <img class="avatar" v-if="avater" :src="baseURL + avater" alt="用户头像" />
              <svg-icon v-else class="awatar" icon-class="awatar"></svg-icon>
              <div class="username">{{ username }}</div>
              <svg-icon icon-class="arrow-down"></svg-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu class="user-dropdown-menu">
                <el-dropdown-item command="user" divided>
                  <i class="el-icon-user" style="margin-right: 8px"></i>
                  个人中心
                </el-dropdown-item>
                <el-dropdown-item command="logout" divided>
                  <i class="el-icon-switch-button" style="margin-right: 8px"></i>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </el-row>
    <!-- 推送公告 -->
    <el-dialog class="add-Notice-dialog" title="未读消息" :visible.sync="pushNoticeDialogVisible" width="680px" :close-on-click-modal="false">
      <div class="notice">
        <el-scrollbar style="height: 100%">
          <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
            <h5>{{ item.noticeTitle }}</h5>
            <p>{{ item.noticeContent }}</p>
          </div>
          <el-empty v-if="noticeCount == 0" description="暂无未读消息"></el-empty>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer" v-if="noticeCount > 0">
        <el-button @click="pushNoticeDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="submitReadNotice()">一键已读</el-button>
      </div>
    </el-dialog>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" class="app-container" />
    </transition>
  </section>
</template>

<script>
import { baseURL } from '@/utils/config.js'
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
  data() {
    return {
      baseURL,
      username: '管理员',
      avater: '',
      noticeCount: 0,
      pushNoticeDialogVisible: false,
      noticeList: []
    }
  },
  created() {
    // this.getInfo()
    const userInfo = this.$getCache('crm_user')
    if (userInfo) {
      this.username = userInfo.nickName
      this.avater = userInfo.avatar
    }
    this.getNoticeCount()
    this.getNotice()
  },
  methods: {
    // 首页获取用户的公告列表
    getNotice() {
      this.$api.indexNotice().then((res) => {
        if (res.code == 200) {
          this.noticeList = res.data.filter((item) => item.readStatus === 0)
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    // 首页获取用户的公告数量
    getNoticeCount() {
      this.$api.indexNoticeCount().then((res) => {
        if (res.code == 200) {
          this.noticeCount = res.data
          if (res.data > 0) {
            this.pushNoticeDialogVisible = true
          }
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    submitReadNotice() {
      this.$api.indexNoticeRead().then((res) => {
        if (res.code == 200) {
          this.$message({ message: res.msg, type: 'success' })
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'user') {
        this.$router.push('/user')
      }
    },
    logout() {
      this.$clearCache('crm_token')
      this.$clearCache('crm_user')
      this.$message.success('已退出登录')
      setTimeout(() => {
        this.$router.push('/login')
      }, 1200)
    },
    getInfo() {
      this.$api.getInfo().then((res) => {
        if (res.code == 200) {
          this.$setCache('crm_user', res.user)
          this.username = res.user.nickName
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    }
  }
}
</script>

<style scoped>
.notice {
  height: 356px;
  overflow: hidden;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .notice-item {
    padding-right: 6px;
    padding-bottom: 4px;
    margin-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
    h5,
    p {
      margin: 0;
    }
    h5 {
      font-size: 14px;
      line-height: 17px;
    }
    p {
      font-size: 12px;
      line-height: 30px;
    }
  }
}
.el-dropdown-menu__item--divided {
  border-top: none !important;
}
.el-dropdown-menu {
  width: 148px !important;
  border-radius: 6px !important;
}
.app-main {
  min-height: 100vh;
  width: 100%;
  position: relative;
  padding: 22px 25px;
  .top {
    height: 52px;
    position: sticky;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .left {
      background: #fff;
      padding: 16px 22px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .svg-icon {
        font-size: 20px;
        margin-right: 8px;
        flex-shrink: 0;
      }
      .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }
    }
    .right {
      margin-left: 20px;
      display: flex;
      justify-content: flex-end;
      .notice-stroke-wrap,
      .search-wrap {
        font-size: 52px;
        margin-right: 10px;
        cursor: pointer;
      }
      .notice-stroke-wrap {
        position: relative;
        .mark {
          position: absolute;
          top: -29px;
          right: 0;
        }
      }
      .user-info-wrap {
        margin-left: 7px;
        background: #fff;
        line-height: 52px;
        min-width: 148px;
        height: 52px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .avatar {
          width: 35px;
          height: 35px;
          border-radius: 100%;
          margin-left: 18px;
          margin-right: 11px;
        }
        .svg-icon {
          font-size: 12px;
          margin-right: 18px;
        }
        .awatar {
          font-size: 35px;
          margin-left: 18px;
          margin-right: 11px;
        }
        .username {
          font-size: 16px;
          color: #000;
          margin-right: 11px;
        }
      }
    }
  }
}
</style>
